import { useParams, Link } from "react-router-dom";
import { useState } from "react";
import Header from "../../../components/feature/Header";
import Footer from "../../../components/feature/Footer";

// Tipo para los acabados
interface Acabado {
  id: string;
  nombre: string;
  imagen: string;
}

// Datos de maderas con sus acabados
const maderas = [
  {
    id: 1,
    nombre: "Roble",
    slug: "roble",
    imagen: "/images/maderas_naturales/roble/roble_natural.webp",
    categoria: "roble",
    descripcion:
      "El Roble es una madera versátil que da lugar a distintos acabados. En este caso hablamos de la variante de roble sin nudos.",
    acabados: [
      {
        id: "roble-natural",
        nombre: "Roble Natural",
        imagen: "/images/maderas_naturales/roble/roble_natural.webp",
      },
      {
        id: "roble-tierra",
        nombre: "Roble Tierra",
        imagen: "/images/maderas_naturales/roble/roble_tierra.webp",
      },
      {
        id: "roble-stone",
        nombre: "Roble Stone",
        imagen: "/images/maderas_naturales/roble/roble_stone.webp",
      },
      {
        id: "roble-pure-nature",
        nombre: "Roble Pure Nature",
        imagen: "/images/maderas_naturales/roble/roble_pure_nature.webp",
      },
      {
        id: "roble-oscurecido",
        nombre: "Roble Oscurecido",
        imagen: "/images/maderas_naturales/roble/roble_oscurecido.webp",
      },
      {
        id: "roble-nordico",
        nombre: "Roble Nordico",
        imagen: "/images/maderas_naturales/roble/roble_nordico.webp",
      },
      {
        id: "roble-glaseado-negro",
        nombre: "Roble Glaseado Negro",
        imagen: "/images/maderas_naturales/roble/roble_glaseado_negro.webp",
      },
      {
        id: "roble-abedul",
        nombre: "Roble Abedul",
        imagen: "/images/maderas_naturales/roble/roble_abedul.webp",
      },
      {
        id: "roble-crudo",
        nombre: "Roble Crudo",
        imagen: "/images/maderas_naturales/roble/roble_crudo.webp",
      },
      {
        id: "roble-ceniza",
        nombre: "Roble Ceniza",
        imagen: "/images/maderas_naturales/roble/roble_ceniza.webp",
      },
      {
        id: "roble-canela",
        nombre: "Roble Canela",
        imagen: "/images/maderas_naturales/roble/roble_canela.webp",
      },
      {
        id: "roble-cambrian",
        nombre: "Roble Cambrian",
        imagen: "/images/maderas_naturales/roble/roble_cambrian.webp",
      },
      {
        id: "roble-blanco-patinado",
        nombre: "Roble Blanco Patinado",
        imagen: "/images/maderas_naturales/roble/roble_blanco_patinado.webp",
      },
      {
        id: "roble-blanco",
        nombre: "Roble Blanco",
        imagen: "/images/maderas_naturales/roble/roble_blanco.webp",
      },
      {
        id: "roble-azul",
        nombre: "Roble Azul",
        imagen: "/images/maderas_naturales/roble/roble_azul.webp",
      },
      {
        id: "roble-aceituna",
        nombre: "Roble Aceituna",
        imagen: "/images/maderas_naturales/roble/roble_aceituna.webp",
      },
    ],
  },
  {
    id: 2,
    nombre: "Roble Vintage",
    slug: "roble-vintage",
    imagen: "/images/maderas_naturales/roble_vintage.webp",
    categoria: "roble",
    descripcion:
      "Roble Vintage: tablero compuesto por chapa seleccionada del interior del tronco del roble. Las grietas naturales y nudos abiertos resaltan su carácter.",
    acabados: [
      {
        id: "roble-vintage-natural",
        nombre: "Roble Vintage Natural",
        imagen: "/images/maderas_naturales/roble_vintage/roble_vintage_natural.webp",
      },
    ],
  },
  {
    id: 3,
    nombre: "Nogal",
    slug: "nogal",
    imagen: "/images/maderas_naturales/nogal.webp",
    categoria: "nogal",
    descripcion:
      "La preciosa madera de Nogal es un clásico en nuestra gama. Optamos por acabados naturales para preservar su personalidad y elegancia.",
    acabados: [
      {
        id: "nogal-natural",
        nombre: "Nogal Natural",
        imagen: "/images/maderas_naturales/nogal/nogal_natural.webp",
      },
      {
        id: "nogal-pure-nature-gris",
        nombre: "Nogal Pure Nature",
        imagen: "/images/maderas_naturales/nogal/nogal_pure_nature.webp",
      },
    ],
  },
  {
    id: 4,
    nombre: "Mongoy (Ovangkol)",
    slug: "mongoy-ovangkol",
    imagen: "/images/maderas_naturales/mongoy.webp",
    categoria: "tropical",
    descripcion:
      "La madera de Mongoy, también conocida como Ovangkol, destaca por su estética versátil y combinaciones de tonalidades en sus vetas.",
    acabados: [
      {
        id: "mongoy-natural",
        nombre: "Mongoy Natural",
        imagen: "/images/maderas_naturales/mongoy/mongoy.webp",
      },
      {
        id: "mongoy-pure-nature",
        nombre: "Mongoy Pure Nature",
        imagen: "/images/maderas_naturales/mongoy/mongoy_lavado.webp",
      },
    ],
  },
  {
    id: 5,
    nombre: "Etimoe",
    slug: "etimoe",
    imagen: "/images/maderas_naturales/etimoe.webp",
    categoria: "tropical",
    descripcion:
      "La madera de Etimoe, de procedencia tropical, posee unas vetas distintivas que van desde un marrón oscuro hasta tonalidades rojizas. Una madera elegante que aporta toques exóticos y exclusivos a tu baño.",
    acabados: [
      {
        id: "etimoe-natural",
        nombre: "Etimoe Natural",
        imagen: "/images/maderas_naturales/etimoe/etimoe_natural.webp",
      },
      {
        id: "etimoe-pure-nature",
        nombre: "Etimoe Pure Nature",
        imagen: "/images/maderas_naturales/etimoe/etimoe_lavado.webp",
      },
    ],
  },
  {
    id: 6,
    nombre: "Ébano",
    slug: "ebano",
    imagen: "/images/maderas_naturales/ebano/ebano.webp",
    categoria: "tropical",
    descripcion:
      "La madera de Ébano destaca por la tonalidad de su madera, que entrelaza vetas negras con vetas de tonalidad marrón oscura. Ideal para ambientes exóticos y exclusivos.",
    acabados: [
      {
        id: "ebano-natural",
        nombre: "Ébano Natural",
        imagen: "/images/maderas_naturales/ebano/ebano.webp",
      },
    ],
  },
  {
    id: 7,
    nombre: "Zebrano",
    slug: "zebrano",
    imagen: "/images/maderas_naturales/zebrano/zebrano.webp",
    categoria: "tropical",
    descripcion:
      "La madera Zebrano es de origen tropical. Sus vetas tienen una transición más suave, desde tonalidades marrón claro casi amarillentas hasta líneas diferenciadas de marrón marcado.",
    acabados: [
      {
        id: "zebrano-natural",
        nombre: "Zebrano Natural",
        imagen: "/images/maderas_naturales/zebrano/zebrano.webp",
      },
    ],
  },
];

export default function MaderaDetallePage() {
  const { slug } = useParams<{ slug: string }>();
  const madera = slug ? maderas.find((m) => m.slug === slug) : undefined;
  
  // Estado para la imagen ampliada
  const [imagenAmpliada, setImagenAmpliada] = useState<Acabado | null>(null);

  const abrirImagenAmpliada = (acabado: Acabado) => {
    setImagenAmpliada(acabado);
    document.body.style.overflow = 'hidden';
  };

  const cerrarImagenAmpliada = () => {
    setImagenAmpliada(null);
    document.body.style.overflow = 'unset';
  };

  return (
    <>
      <div className="min-h-screen bg-gray-50">
        <Header />
        
        {/* Hero Section */}
        <div className="bg-white">
          <div className="w-full mx-auto text-center flex items-center justify-center min-h-screen" style={{ padding: 'clamp(2rem, 4vh, 6rem) clamp(1rem, 3vw, 5rem)' }}>
            <div>
              <h1 
                className="font-light text-gray-900" 
                style={{ 
                  fontFamily: 'Playfair Display, serif',
                  fontSize: 'clamp(2.5rem, 5vw, 7rem)',
                  marginBottom: 'clamp(1rem, 2vh, 3rem)'
                }}
              >
                MADERAS NATURALES
              </h1>
              <p 
                className="text-gray-900 max-w-[1400px] mx-auto leading-relaxed" 
                style={{ 
                  fontFamily: 'Cormorant Garamond, serif',
                  fontSize: 'clamp(1rem, 1.2vw, 2rem)',
                  padding: '0 clamp(1rem, 2vw, 3rem)'
                }}
              >
                <b>Fabricado sobre tablero marino hidrófugo. Láminas exteriores compuestas por la madera natural escogida. Núcleo compuesto por láminas de madera de abedul macizas.</b>
                <br /><br />
                <b>Tratamiento especial para resistir la humedad del baño</b>
              </p>
            </div>
          </div>
        </div>

      {!madera ? (
        <main className="p-8 text-center">
          <h1 className="text-2xl font-semibold">Madera no encontrada</h1>
          <p>No hemos encontrado una madera con ese identificador.</p>
          <div className="mt-6">
            <Link
              to="/maderas"
              className="inline-block px-4 py-2 bg-gray-900 text-white rounded"
            >
              Volver a Maderas
            </Link>
          </div>
        </main>
      ) : (
        <main className="bg-white rounded-lg overflow-hidden">
          {/* Hero con imagen como background (responsive) */}
          <section
            className="relative overflow-hidden mx-auto rounded-lg w-full md:w-[70%] lg:w-[60%]"
            style={{
              height: 'clamp(40vh, 60vh, 80vh)',
              backgroundImage: `url(${madera.imagen})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}
          >
            <div className="absolute inset-0 bg-black/35 flex items-center justify-center text-center px-6">
              <div className="text-white max-w-3xl mx-auto">
                <h2
                  className="font-light"
                  style={{
                    fontFamily: "Playfair Display, serif",
                    fontSize: "clamp(2rem, 5vw, 5rem)",
                    lineHeight: 1.1,
                    marginBottom: "clamp(0.5rem, 1vh, 1.5rem)",
                    textShadow: "0 2px 8px rgba(0,0,0,0.45)"
                  }}
                >
                  {madera.nombre.toUpperCase()}
                </h2>

                <p
                  className="opacity-90"
                  style={{
                    fontFamily: "Cormorant Garamond, serif",
                    fontSize: "clamp(1rem, 1.5vw, 1.25rem)",
                    lineHeight: 1.5,
                    textShadow: "0 1px 6px rgba(0,0,0,0.45)"
                  }}
                >
                  {madera.descripcion}
                </p>
              </div>
            </div>
          </section>

          {/* Grid de acabados mejorada tipo galería profesional */}
          <section className="w-full px-4 sm:px-8 py-12 bg-white">
            <div className="mx-auto">
              <div className="border-b border-gray-200" style={{ padding: 'clamp(1rem, 1.5vw, 2rem) 0' }}>
                <div className="flex items-center space-x-2 text-gray-700">
                  <span 
                    className="font-medium" 
                    style={{ 
                      fontFamily: 'Playfair Display, serif',
                      fontSize: 'clamp(1rem, 1.5vw, 1.5rem)'
                    }}
                  >
                    Acabados disponibles
                  </span>
                </div>
              </div>

              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-x-4 gap-y-8 justify-items-center mt-8">
                {madera.acabados.map((ac) => (
                  <div
                    key={ac.id}
                    className="flex flex-col items-center text-center transition-transform duration-300 hover:scale-105 cursor-pointer"
                    onClick={() => abrirImagenAmpliada(ac)}
                  >
                    <div className="relative w-full aspect-square overflow-hidden rounded-lg shadow-sm group">
                      <img
                        src={ac.imagen}
                        alt={`Muebles de baño madera ${madera.nombre} ${ac.nombre} - Navamuel`}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      />
                      {/* Capa de overlay sutil al hacer hover */}
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300"></div>
                    </div>

                    <span
                      className="mt-3 text-gray-900 font-medium"
                      style={{
                        fontFamily: "Cormorant Garamond, serif",
                        fontSize: "clamp(0.9rem, 1vw, 1.1rem)",
                      }}
                    >
                      {ac.nombre}
                    </span>
                  </div>
                ))}
              </div>

              {/* Botón para volver */}
              <div className="text-center mt-10">
                <Link
                  to="/maderas"
                  className="inline-block text-gray-600 hover:text-gray-900 underline transition-colors text-sm"
                >
                  ← Volver a Maderas
                </Link>
              </div>
            </div>
          </section>
        </main>
      )}

      <Footer />
      </div>

      {/* Modal de Imagen Ampliada */}
      {imagenAmpliada && (
        <div className="fixed inset-0 bg-[#191a19]/80 z-50 flex items-center justify-center" style={{ padding: 'clamp(1rem, 2vw, 2rem)' }}>
          <div 
            className="relative w-full bg-white rounded-lg overflow-hidden"
            style={{ 
              maxWidth: 'clamp(300px, 80vw, 1200px)',
              maxHeight: '90vh'
            }}
          >
            <button
              onClick={cerrarImagenAmpliada}
              className="absolute z-10 bg-white/90 hover:bg-white rounded-full flex items-center justify-center cursor-pointer transition-colors"
              style={{
                top: 'clamp(0.5rem, 1vw, 1rem)',
                right: 'clamp(0.5rem, 1vw, 1rem)',
                width: 'clamp(2rem, 3vw, 2.5rem)',
                height: 'clamp(2rem, 3vw, 2.5rem)'
              }}
            >
              <i className="ri-close-line text-gray-800" style={{ fontSize: 'clamp(1rem, 1.5vw, 1.25rem)' }}></i>
            </button>
            
            <div style={{ padding: 'clamp(1rem, 2vw, 2rem)' }}>
              <div className="grid grid-cols-1 lg:grid-cols-2" style={{ gap: 'clamp(1rem, 3vw, 3rem)' }}>
                <div className="aspect-square overflow-hidden rounded-lg shadow-2xl ring-1 ring-black/10">
                  <img
                    src={imagenAmpliada.imagen}
                    alt={`Muebles de baño madera ${madera.nombre} ${imagenAmpliada.nombre} - Detalle`}
                    className="w-full h-full object-cover"
                  />
                </div>
                
                <div className="flex flex-col justify-center items-center">
                  <h2 
                    className="font-light text-gray-900" 
                    style={{ 
                      fontFamily: 'Playfair Display, serif',
                      fontSize: 'clamp(1.5rem, 3vw, 4rem)',
                      marginBottom: 'clamp(0.5rem, 1vh, 2rem)'
                    }}
                  >
                    {imagenAmpliada.nombre}
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}